export const DATE_COMMON_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const ONLY_DATE_COMMON_FORMAT = 'yyyy-MM-dd';
export const TIME_COMMON_FORMAT = 'HH:mm:ss';
